module.exports = __webpack_public_path__ + "static/media/ngoRed.063997bb.svg";